import * as React from 'react';
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { useState } from "react";
import RefreshIcon from '@mui/icons-material/Refresh';
import ReplayIcon from '@mui/icons-material/Replay';
import useStore from "../../../../store/store";
import {middleRegulatorsUkrNames, middleRegulatorsEngNames} from '../../../../constants/constants'

const MiddleRegulator = ({ regulatorName }) => {
    // arrow of regulators on full value and inactive
    const [value, setValue] = useState(3);
    const [selectedIndex, setSelectedIndex] = useState(3);

    const stepValues = [0, 1, 2, 3];

    const changeFocus = useStore((state) => state.changeFocus);
    const changeBrightness = useStore((state) => state.changeBrightness);
    const changeStab = useStore((state) => state.changeStab);
    const changeLevel = useStore((state) => state.changeLevel);

    const getFunctionFromName = (regulatorName, valueForState) => {
        switch (true){
            case (regulatorName === middleRegulatorsEngNames.ENGFOCUSNAME || regulatorName === middleRegulatorsUkrNames.RUSFOCUSNAME):
                return changeFocus(valueForState);
            case (regulatorName === middleRegulatorsEngNames.ENGBRIGHTNAME || regulatorName === middleRegulatorsUkrNames.RUSBRIGHTNAME):
                return changeBrightness(valueForState)
            case (regulatorName === middleRegulatorsEngNames.ENGSTABNAME || regulatorName === middleRegulatorsUkrNames.RUSSTABNAME):
                return changeStab(valueForState)
            case (regulatorName === middleRegulatorsEngNames.ENGLEVELNAME || regulatorName === middleRegulatorsUkrNames.RUSLEVELNAME):
                return changeLevel(valueForState)
            default:
                return console.log('error with regulators')
        }
    }

    const handleIncrement = () => {
        const currentIndex = stepValues.indexOf(value);
        const nextIndex = Math.min(currentIndex + 1, stepValues.length - 1);
        setValue(stepValues[nextIndex]);
        setSelectedIndex(nextIndex);
        getFunctionFromName(regulatorName, stepValues[nextIndex])
    };

    const handleDecrement = () => {
        const currentIndex = stepValues.indexOf(value);
        const nextIndex = Math.max(currentIndex - 1, 0);
        setValue(stepValues[nextIndex]);
        setSelectedIndex(nextIndex);
        getFunctionFromName(regulatorName, stepValues[nextIndex])
    };


    const rotationAngle = (selectedIndex / stepValues.length) * 360;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '20px' }}>
                <Typography sx={{fontWeight: 'bold'}}>{regulatorName}</Typography>
                <Box sx={{display: 'flex'}}>
                    <Box
                        sx={{
                            position: 'relative',
                            width: '45px',
                            height: '45px',
                            borderRadius: '50%',
                            backgroundColor: 'gray',
                            fontSize: '1.2em',
                            cursor: 'pointer',
                            overflow: 'hidden',
                        }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '70%',
                                left: '50%',
                                transform: `translate(-50%, -50%) rotate(${rotationAngle}deg)`,
                                width: '2px',
                                height: '20px',
                                backgroundColor: 'black',
                                transformOrigin: 'top',
                            }}
                        />
                    </Box>
                </Box>


                {/*<Box sx={{ display: 'flex', marginTop: '30px' }}>*/}
                {/*    <button onClick={handleDecrement}><ReplayIcon/></button>*/}
                {/*    <button onClick={handleIncrement}><RefreshIcon/></button>*/}
                {/*</Box>*/}
            </Box>
        </Box>
    );
};

export default MiddleRegulator;
